<template>
  <footer class="mt-3 mt-lg-0">
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-md-6 d-flex justify-content-center">
          <p>Realización <img src="@/assets/logo-gray.png" alt="Logo" /></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
p {
  @include typography1(13, 13, $gray-2, 400);
  img {
    margin-left: 20px;
  }
}
</style>
